import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { MessageSquare, Plus, Search } from 'lucide-react';
import { api } from '../../api';
import { pode, useSessao } from '../../sessao';
import { Modal } from '../../componentes/Modal';
import { telefone } from '../../componentes/formatos';
import { NOME_PRIORIDADE } from '../agenda/comum';
import { FormChamado } from './FormChamado';
import { NOME_ORIGEM, NOME_STATUS_CHAMADO, idade, type ChamadoItem } from './comum';

const SITUACOES = [['abertos', 'Em aberto'], ['novos', 'Sem triagem'], ['fechados', 'Fechados'], ['todos', 'Todos']] as const;

export function ListaChamados() {
  const { usuario } = useSessao();
  const navegar = useNavigate();
  const [params, setParams] = useSearchParams();
  const situacao = params.get('situacao') ?? 'abertos';
  const [busca, setBusca] = useState(params.get('busca') ?? '');
  const [itens, setItens] = useState<ChamadoItem[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [novo, setNovo] = useState(false);
  const podeAtender = pode(usuario, 'chamados.atender');

  useEffect(() => {
    const q = new URLSearchParams({ situacao });
    if (params.get('busca')) q.set('busca', params.get('busca')!);
    setErro(null);
    api<ChamadoItem[]>(`/chamados?${q}`).then(setItens).catch((e) => setErro(e.message));
  }, [params, situacao]);
  useEffect(() => {
    const t = setTimeout(() => {
      if ((params.get('busca') ?? '') === busca) return;
      const p = new URLSearchParams(params); busca ? p.set('busca', busca) : p.delete('busca'); setParams(p, { replace: true });
    }, 300);
    return () => clearTimeout(t);
  }, [busca]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtro = (v: string) => { const p = new URLSearchParams(params); v === 'abertos' ? p.delete('situacao') : p.set('situacao', v); setParams(p); };

  return (
    <>
      <div className="cabecalho-pagina">
        <div><span className="kicker">Operação</span><h1 className="titulo">Chamados</h1></div>
        {podeAtender && <button className="btn" onClick={() => setNovo(true)}><Plus size={18} aria-hidden /> Novo chamado</button>}
      </div>

      <div className="barra-agenda">
        <div className="alternador" role="tablist">
          {SITUACOES.map(([v, r]) => (
            <button key={v} role="tab" aria-selected={situacao === v} className={situacao === v ? 'ativo' : ''} onClick={() => filtro(v)}>{r}</button>
          ))}
        </div>
        <div className="filtros-os">
          <label className="campo-busca"><Search size={18} strokeWidth={1.7} aria-hidden />
            <input type="search" value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Número, cliente, quem pediu, telefone" aria-label="Buscar chamados" />
          </label>
        </div>
      </div>

      {erro && <p className="alerta" role="alert">{erro}</p>}
      <section className="cartao tabela-cartao">
        {itens === null ? <p className="carregando-tabela">Carregando…</p> : itens.length === 0 ? (
          <div className="vazio"><MessageSquare size={28} aria-hidden /><p>Nenhum chamado {situacao === 'fechados' ? 'fechado' : situacao === 'novos' ? 'esperando triagem' : situacao === 'abertos' ? 'em aberto' : ''}.</p></div>
        ) : (
          <table className="tabela tabela-os tabela-chamados">
            <thead><tr><th>Chamado</th><th>Situação</th><th>Cliente · parque</th><th>Pedido</th><th>Quem pediu</th><th>Chegou</th></tr></thead>
            <tbody>
              {itens.map((c) => (
                <tr key={c.id} onClick={() => navegar(`/chamados/${c.id}`)}>
                  <td><Link to={`/chamados/${c.id}`}><strong className="mono">{c.numero}</strong></Link>
                    <small><span className={`pill-prioridade p-${c.prioridade}`}>{NOME_PRIORIDADE[c.prioridade]}</span></small></td>
                  <td><span className={`status ch-${c.status}`}>{NOME_STATUS_CHAMADO[c.status]}</span>
                    {c.os_total > 0 && <small>{c.os_total} OS{c.os_abertas ? ` · ${c.os_abertas} aberta${c.os_abertas > 1 ? 's' : ''}` : ''}</small>}</td>
                  <td>{c.cliente ?? <span className="nota">a identificar</span>}<small>{c.local ?? ''}</small></td>
                  <td><small className="descricao-curta">{c.descricao}</small></td>
                  <td>{c.contato ?? c.solicitante_nome ?? '—'}<small>{c.solicitante_telefone ? telefone(c.solicitante_telefone) : ''}</small></td>
                  <td>{idade(c.criado_em)}<small>{NOME_ORIGEM[c.origem]}</small></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {itens && itens.length >= 300 && <p className="nota rodape-tabela">Mostrando os 300 primeiros. Use a busca.</p>}
      </section>

      <Modal titulo="Novo chamado" aberto={novo} aoFechar={() => setNovo(false)}>
        {novo && <FormChamado aoCancelar={() => setNovo(false)} aoSalvar={(r) => { setNovo(false); navegar(`/chamados/${r.id}`); }} />}
      </Modal>
    </>
  );
}
